"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const MenuLoading = (props) => {
    return ((0, jsx_runtime_1.jsx)("div", { style: { paddingLeft: 10, paddingRight: 10 }, children: Array.from({ length: props.count || 1 }, (_, index) => ((0, jsx_runtime_1.jsx)("span", { className: 'placeholder placeholder-menu-loading mb-1', style: { height: props.height || 20 } }, index))) }));
};
exports.default = MenuLoading;
